



















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Room } from "@/types";
import VideoParticipants from "@/components/room/VideoParticipants.vue";
import VideoBox from "@/components/room/VideoBox.vue";
import VideoPlayer from "@/components/room/VideoPlayer.vue";

import * as twilio from "twilio-video";

@Component({ components: { VideoBox, VideoParticipants, VideoPlayer } })
export default class VideoGridListening extends Vue {
  @Prop({ required: true })
  room!: Room;

  @Prop({ required: true })
  myId!: string;

  @Prop({ required: true })
  remoteParticipants!: Record<string, twilio.RemoteParticipant>;

  @Prop({ required: true })
  localParticipant!: twilio.LocalParticipant;

  @Watch("room")
  onRoomChange(newRoom: Room, oldRoom: Room) {
    const video = this.$refs.songVideo as VideoPlayer;
    if (video) {
      if (newRoom.currentVideoTime !== oldRoom.currentVideoTime) {
        video.setCurrentTime(newRoom.currentVideoTime);
        if (!newRoom.currentVideoPaused) {
          video.forcePlay();
        }
      }
      if (newRoom.currentVideoPaused !== oldRoom.currentVideoPaused) {
        if (newRoom.currentVideoPaused) {
          video.forcePause();
        } else {
          video.forcePlay();
        }
      }
    }
  }

  get currentHref() {
    return window.location.href;
  }

  get currentSong() {
    return this.room.currentSong || this.room.onDeck;
  }

  filterParticipant(
    participantid: string,
    participants: Record<string, twilio.Participant>,
  ): Record<string, twilio.Participant> {
    const res: Record<string, twilio.Participant> = {};
    Object.keys(participants).forEach(key => {
      if (key !== participantid) {
        res[key] = participants[key];
      }
    });
    return res;
  }

  participant(participantid: string): twilio.Participant {
    return this.remoteParticipants[participantid];
  }
}
